<svg height="100%" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path
    d="M16 34C7.16344 34 3.86258e-07 26.8366 0 18C-3.86258e-07 9.16344 7.16344 2 16 2L20 2C28.8366 2 36 9.16344 36 18C36 26.8366 28.8366 34 20 34H16Z"
    class="background"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M18 11.9395L24.0607 18.0001L18 24.0608L16.9393 23.0001L21.1893 18.7501H12.25V17.2501H21.1893L16.9393 13.0001L18 11.9395Z"
    class="foreground"
  />
</svg>
